<template>
  <div class="landing-page-panels">
    <a v-for="category in categories" class="landing-page-panel _new" :href="'/training/category/'+category.id">
      <div class="box">
        <div class="image">
          <img :src="'/images/training-category-landing-page-thumbnail-'+category.id+'.png'">
        </div>
        <div class="content">
          <div class="title">
            {{ category.label }}
          </div>
          <div class="description">
            {{ category.description }}
          </div>
        </div>
        <div class="footer">
          <div class="logo">
            <img v-if="category.id === 1" src="/images/powered-by-logo-gqa-qualifications.png">
            <img v-else src="/images/powered-by-logo-building-our-skills.png">
          </div>
          <div class="powered-by">
            <div>Powered By</div>
            <div v-if="category.id === 1">GQA Qualifications</div>
            <div v-else>Building Our Skills</div>
          </div>
          <div class="button">
            <div class="btn">
              <i class="fa fa-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
    mounted() {
        this.loadCategories();
    },
    data() {
        return {
            categories: [],
        }
    },
    methods: {
        loadCategories() {
            axios.post('/training/loadCourseCategoriesAvailableForUser').then((response) => {
                this.categories = response.data;
            });
        },
    },
}
</script>
